import { Button } from "@mui/material";

import { useTranslation } from "react-i18next";

const NestpaySelectCurrency = ({ currency, setCurrency }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full">
            <div className="font-medium mb-1 text-sm text-left">
                {t("bills.bill_info.select_currency")}
            </div>
            <div className="w-full flex gap-6 justify-start items-center text-center">
                <Button
                    variant="contained"
                    sx={{
                        color: currency === "USD" ? "#fff" : "#000",
                        bgcolor: currency === "USD" ? "#059669" : "#fff",
                        fontSize: "0.7rem",
                        padding: "0.1rem 0.5rem",
                        width: "fit-content",
                        ":hover": {
                            color: "#fff",
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={() => setCurrency("USD")}
                >
                    <span className="font-medium text-xs">$&nbsp;</span>
                    USD
                </Button>
                <Button
                    variant="contained"
                    sx={{
                        color: currency === "EUR" ? "#fff" : "#000",
                        bgcolor: currency === "EUR" ? "#059669" : "#fff",
                        fontSize: "0.7rem",
                        padding: "0.1rem 0.5rem",
                        width: "fit-content",
                        ":hover": {
                            color: "#fff",
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={() => setCurrency("EUR")}
                >
                    <span className="font-medium text-xs">€&nbsp;</span>
                    EUR
                </Button>
                <Button
                    variant="contained"
                    sx={{
                        color: currency === "TRY" ? "#fff" : "#000",
                        bgcolor: currency === "TRY" ? "#059669" : "#fff",
                        fontSize: "0.7rem",
                        padding: "0.1rem 0.5rem",
                        width: "fit-content",
                        ":hover": {
                            color: "#fff",
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={() => setCurrency("TRY")}
                >
                    <span className="font-medium text-xs">₺&nbsp;</span>
                    TRY
                </Button>
            </div>
        </div>
    );
};

export default NestpaySelectCurrency;
